import { useQuery } from "@apollo/client";

import { gql } from "~/__generated__";
import useCacheFilterOptions from "~/modules/app/hooks/useCacheFilterOptions";
import { FilterParams } from "~/modules/app/types/filterAndPaginationTypes";
import { convertParamsToQueryOptions } from "~/modules/app/util/filterAndPaginationUtils";

import { GqlProjectMetadata } from "./useMeGetProjectInfoQuery";

export const PROJECT_COST_GET_ALL = gql(`
query ProjectCostGetAllForProject($projectId: ID!, $params: GqlProjectCostGetAllParams) {
  projectCostGetAllForProject(projectId: $projectId, params: $params) {
    queryInfo {
      sortableColumns
      filterOptions {
        ... on GqlFilterOptionText {
          filterType
          label
          key
        }
        ... on GqlFilterOptionSelect {
          filterType
          label
          key
          options {
            label
            value
          }
        }
        ... on GqlFilterOptionMultiSelect {
          filterType
          label
          key
          dataModel
        }
        ... on GqlFilterOptionBoolean {
          filterType
          label
          key
        }
      }
      paginationOption {
        page
        total
      }
    }
    data {
      id
      name
      data {
        ... on GqlSpeciesResearchCostSpec {
          type
          travelCost
          travelDistance
          travelDuration
          subTotal
          vat
          total
          prices {
              id
              protocolName
              areaCount
              travelCost
              travelTime
              workTime
              total
          }
          protocols {
              id
              name
              total
              visits {
                  id
                  number
                  minDuration
                  pricePerHour
                  total
                  combinationRound
                  totalIncludingTravel
              }
          }
        }
      }
    }
  }
}
`);

export default function useProjectCostGetAllForProject(project: GqlProjectMetadata, params: FilterParams) {
    const { data, loading, error } = useQuery(PROJECT_COST_GET_ALL, {
        variables: {
            projectId: project.id,
            params: convertParamsToQueryOptions(params),
        },
    });

    const queryInfo = data?.projectCostGetAllForProject?.queryInfo;
    const [filterOptions, total] = useCacheFilterOptions(queryInfo?.filterOptions, queryInfo?.paginationOption.total);

    return {
        loading,
        error,
        totalRows: total,
        sortableColumns: queryInfo?.sortableColumns,
        filterOptions: filterOptions,
        data: data?.projectCostGetAllForProject?.data,
    };
}
